/**
 * Import blocks
 */

import './simple-sitemap';
import './simple-sitemap-group';
